import { render, staticRenderFns } from "./ActualizarStock.vue?vue&type=template&id=b8b75994&"
import script from "./ActualizarStock.vue?vue&type=script&lang=js&"
export * from "./ActualizarStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports